import { ApiUserRole } from '@/enum/ApiUserRole'
import { TemplateMail } from '@/enum/TemplateMail'
import { AloBase, getDefaultAloBase } from './AloBase'
import { AloSejour } from './AloSejour'


export interface AloUser extends AloBase {
            
    usrValide: boolean
    usrEmail: string
    usrPasswordToken: string
    usrType: number|null
    usrNom: string
    usrPrenom: string    
    usrDatadd: string|null
    usrRole: ApiUserRole|null    
    currentSejour: AloSejour|null
    autologin:string    
    mtpId: TemplateMail|null
}

export const getDefaultAloUser = (role:ApiUserRole = ApiUserRole.Visiteur):AloUser => {
    return {  
        ...getDefaultAloBase(),        
        usrValide : true,
        usrEmail: "",
        usrPasswordToken:"",
        usrType:null,
        usrNom:"",
        usrPrenom:"",        
        usrDatadd:null,
        usrRole:role,
        currentSejour:null,
        autologin:'',
        mtpId:null
    }
}


export const cleanAloUser = (user:AloUser) => {
    if(!user) return    
    if(!user.id) delete user.id
    if(!user.usrType) delete user.usrType    
    if(!user.mtpId) delete user.mtpId    
}

